import request from '@/utils/request'

export function getSubTransactionListApi(query) {
  return request({
    url: '/config-service/v1/transaction/sub-transaction/',
    method: 'get',
    params: query
  })
}

export function getSubTransactionListSimpleApi(query) {
  return request({
    url: '/config-service/v1/transaction/sub-transaction/list-simple',
    method: 'get',
    params: query
  })
}
